import { Col, NotificationBar, Row } from "@emanprague/ppaskit";
import iconInfo from "@emanprague/ppaskit/dist/assets/icons/Info.svg";
import iconDanger from "@emanprague/ppaskit/dist/assets/icons/State/Not Ok.svg";
import iconWarning from "@emanprague/ppaskit/dist/assets/icons/Warning.svg";
import { observer } from "mobx-react-lite";
import React from "react";
import DOMPurify from "dompurify";
import type { Variant } from "@emanprague/ppaskit/dist/VariantPicker";
import { useId } from "../../helpers/utils";

interface NoticeBarProps {
  content: string | React.ReactNode;
  onCancel?: () => void;
  variant?: Variant;
  showIcon?: boolean;
  textAlign?: "left" | "center" | "right";
  className?: string;
  translateFunc: (key: string) => string;
}

export const NoticeBar: React.FunctionComponent<NoticeBarProps> = observer(
  ({ content, onCancel, showIcon = true, textAlign = "left", variant, className, translateFunc }) => {
    variant = variant ?? "info"; // Default to "info" if variant is not provided or is null/undefined
    let icon;
    switch (variant) {
      case "danger":
        icon = iconDanger;
        break;
      case "info":
        icon = iconInfo;
        break;
      case "warning":
        icon = iconWarning;
        break;
      default:
        icon = null;
    }
    const contentId = useId("notificationContent");

    return (
      <NotificationBar
        cancellable={!!onCancel}
        onCancel={onCancel}
        className={className ?? "mb-2"}
        variant={variant}
        translateFunc={translateFunc}
        cancelButtonInfoId={contentId}>
        <Row className="d-lg-flex align-items-center justify-content-center my-md-1" noGutters>
          {showIcon && icon && (
            <Col xs="auto" className="mr-3">
              <img draggable={false} src={icon} alt={translateFunc(`notice_variant.${variant}`)} width={22} height={22} />
            </Col>
          )}
          <Col md="auto" className="d-lg-block" style={{ textAlign: textAlign }}>
            {typeof content === "string" ? (
              <span
                id={contentId}
                className="font-size-sm"
                style={{ whiteSpace: "pre-line" }}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
              />
            ) : (
              <span id={contentId} className="font-size-sm" style={{ whiteSpace: "pre-line" }}>
                {content}
              </span>
            )}
          </Col>
        </Row>
      </NotificationBar>
    );
  }
);
